import React, { Component } from 'react';
import { IonList, IonListHeader, IonItem, IonLabel, IonIcon, IonButton } from '@ionic/react';
import { withTranslation } from '../../lib/translate';
import './index.css';
import { isDefined, forwardTo } from '../../lib/utils';
import { NormalText, SmallText, Spacer, StrongText, Title } from '../../components/common';
import NoData from '../../components/noData';
import Basket from '../../lib/basket';
import { connect } from 'react-redux';
import { getConfig } from '../../appConfig';
import { addOutline } from 'ionicons/icons';

const truncate = (str, max = 15) => {
	let array = str.trim().split(' ');
	const ellipsis = array.length > max ? '...' : '';
	array = array.map((itm, i) => (i === max - 1 ? itm.replace(/,/g, '') : itm));
	return array.slice(0, max).join(' ') + ellipsis;
};

class orderList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			height: 0

		};
	}
	itemList = (__, subCategoryItems, i) => {
		const { profile } = this.props;
		return (subCategoryItems || []).map((item, index) => {
			const selectedResturant = Basket.getRestaurant();
			let itemIsDisabled = false;
			if (selectedResturant && selectedResturant.disabled_skus && selectedResturant.disabled_skus.length > 0) {
				itemIsDisabled = selectedResturant.disabled_skus.includes(item.sku);
			}
			if (item.sku === undefined || itemIsDisabled) {
				return <></>;
			}
			let image = item.itemRichData && item.itemRichData.squareImageUrl ? item.itemRichData.squareImageUrl : '';
			if (image && image.indexOf('http://') !== -1) {
				image = image.replace(/http:\/\//g, 'https://');
			}
			const name = __(Basket.getProductName(item, profile));
			return (
				<div
					key={item.sku + '_' + index + i}
					title={name}
					className={`menu-item box-content  ${!Basket.isProductUnsnoozed(item) ? 'disabled-element' : ''} `}
					onClick={() => (Basket.isProductUnsnoozed(item) ? this.props.showModal(item) : null)}
				>
					{image && image !== '' ?
						<img className="menu-item-image" src={image} /> :
						<img className="menu-item-image" src={Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image} />

					}
					<div className="menu-item-info">
						<div style={{ flex: 1 }} className='menu-item-info-header'>
							<StrongText >{name}</StrongText>
							<StrongText className='primary-color'>{Basket.formatPrice(Basket.getProductCardPrice(item), true)}</StrongText>

						</div>
						{Basket.getProductDescription(item, profile) !== '' &&
							<div>
								<SmallText
									className='menu-item-info-description'
									dangerouslySetInnerHTML={{
										__html: Basket.getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, ''),
									}}
								></SmallText>
							</div>
						}
						<IonButton className='menu-item-button'>
							<IonIcon icon={addOutline} />
							{__('Add')}
						</IonButton>
					</div>
				</div>
			);
		});
	};

	drawCategoryItems = (__, category, items, breadCrumb = null, i, isGroup = false, allGroup = false) => {
		let name = category.name ? breadCrumb + category.name : breadCrumb + '';
		let drawSubCategory = isGroup ? (
			<div className='menu-items-group' ref={this.props.menuRefs[`${name}_${i}`]}>
				<Title>{`${breadCrumb} ${Basket.getCategoryName(category, this.props.profile)}`}</Title>
				<Spacer size={1} />
				<div className="menu-items">{this.subCategoriesList(__, category, breadCrumb + category.name)}</div>
			</div>
		) : (
			<>{items}</>
		);

		return <React.Fragment key={category.type + '_' + name + i}>{drawSubCategory}</React.Fragment>;
	};

	breadCrumb = (name) => {
		let breadCrumb = name !== '' ? name + ' | ' : name;
		return breadCrumb;
	};

	subCategoriesList = (__, category, name) => {
		if (!isDefined(category)) {
			return;
		}
		const categoryItems = category.menuEntry || category.menuEntryGroups || null;
		let items = this.itemList(__, categoryItems);
		let breadCrumb = this.breadCrumb(name);
		if (categoryItems) {
			return categoryItems.map((subCategory, index) => {
				if (subCategory['@type'] === 'group') {
					items = this.itemList(__, subCategory.menuEntry, index);
					const allGroup = subCategory.menuEntry.some((item) => item.type !== 'group');
					return this.drawCategoryItems(__, subCategory, items, breadCrumb, index, true, allGroup);
				} else {
					items = this.itemList(__, [subCategory], index);
					return this.drawCategoryItems(__, subCategory, items, name, index, false);
				}
			});
		}
		return this.drawCategoryItems(__, category, items, name, 0);
	};

	calcHeight = () => {
		const { category } = this.props;
		let height = 0;
		const wrapper = document.querySelector('.menu-items-wrapper')
		setTimeout(() => {
			if (wrapper && isDefined(category)) {
				let orderListHeight = wrapper.clientHeight;
				let lastCategory = wrapper.querySelector(':scope > div').childNodes[wrapper.querySelector(':scope > div').childNodes.length - 1];
				if (!lastCategory) {
					return 0;
				}
				let lastCategoryHeight = lastCategory.clientHeight;
				if (wrapper.clientHeight && lastCategoryHeight) {
					height = orderListHeight - lastCategoryHeight  - 30;
				}
			}
			this.setState({ height })
		}, 500);

	};
	componentDidMount = async () => {
		await this.calcHeight()
	}
	render() {
		const { __, category, children } = this.props;
		return (
			<div className="menu-items-wrapper" onScroll={(e) => this.props.selectCategoryOnScroll(e)} ref={(ref) => (this.orderListItems = ref)}>
				{children}
				<div ref={(ref) => (this.ionList = ref)}>
					{this.subCategoriesList(__, category, '')}

				</div>

				<div style={{ height: this.state.height }}></div>
			</div>
		);
	}
}

const mapStateToProps = (store) => {
	return {
		profile: store.profile.profile,
		restaurantsUpdated: store.restaurants.restaurantsUpdated,
		basketUpdated: store.orders.basketUpdated,
		clientProfile: store.common.clientProfile,
	};
};

export default connect(mapStateToProps)(withTranslation(orderList));
